import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: 8,
  },
  info: {
    fontSize: 14,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: 8,
  },
  // OUTER border – used only when focused or active (light blue)
  outer: {
    borderRadius: 8,
    padding: 2,
    borderWidth: 2,
    borderColor: 'transparent',
    marginLeft: -2,
  },
  outerFocused: {
    borderWidth: 2,
    borderColor: colors.newUI.therapist.blue50,
  },
  // INNER wrapper – base styles + conditional logic inside component
  inner: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 2,
    borderBottomColor: colors.newUI.therapist.primaryBlue80,
  },
  innerSingleLine: {
    height: 52,
  },
  innerActive: {
    backgroundColor: colors.white,
    borderBottomColor: 'transparent',
  },
  innerWarning: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderBottomColor: colors.newUI.therapist.red70,
  },
  input: {
    fontSize: 16,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    padding: 0,
    flex: 1,
    outlineStyle: 'none',
    textAlignVertical: 'center',
    height: 52,
  },
  disabledInput: {
    color: colors.newUI.therapist.grey70,
  },
  innerDisabled: {
    backgroundColor: colors.newUI.therapist.grey20,
    borderBottomColor: colors.newUI.therapist.blue90,
  },
  warningText: {
    color: colors.newUI.therapist.red70,
    fontSize: 14,
    marginTop: 4,
    fontWeight: '400',
  },
  warningIconWrapper: {
    width: 28,
    height: 28,
    borderRadius: 16,
    backgroundColor: colors.newUI.therapist.red70,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
  },
  validatedIconWrapper: {
    width: 28,
    height: 28,
    borderRadius: 16,
    backgroundColor: colors.newUI.therapist.green70,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
  },
  innerValidated: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderBottomColor: colors.newUI.therapist.green70,
  },
  icon: {
    fontSize: 16,
    color: colors.white,
  },
  eyeIconWrapper: {
    height: 52,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
  eyeIcon: {
    fontSize: 28,
    color: colors.newUI.therapist.primaryBlue80,
  },
  required: {
    color: colors.newUI.therapist.red70,
  },
});
